// eslint-disable-next-line @typescript-eslint/ban-types
export type Getters = {};

export const getters: any = {}; // TODO define types
